import { gql } from '@apollo/client/core'
import { DRAFT_CUSTOM_AUDIENCE_ITEM } from './draftCustomAudienceItem'
import DRAFT_CUSTOM_CRITERION_OPTION from './draftCustomCriterionOption'
import { DRAFT_STANDARD_AUDIENCE_ITEM } from './draftStandardAudienceItem'
import DRAFT_STANDARD_CRITERION_OPTION from './draftStandardCriterionOption'

const DRAFT_AUDIENCE_MEMBER = gql`
  fragment DraftAudienceMember on DraftFieldworkAudienceMember {
    id
    number
    position
    contextPosition
    memberType
    isWeighted
    isGlobal
    memberItem {
      __typename
      ...DraftStandardAudienceItem
      ...DraftCustomAudienceItem
    }
  }
  ${DRAFT_STANDARD_AUDIENCE_ITEM}
  ${DRAFT_CUSTOM_AUDIENCE_ITEM}
  ${DRAFT_CUSTOM_CRITERION_OPTION}
  ${DRAFT_STANDARD_CRITERION_OPTION}
`

export default DRAFT_AUDIENCE_MEMBER
